import { Box } from '@mui/material';
import { Dot } from './Dot';

const styles = {
    root: {
        position: 'absolute',
        bottom: '2em',
        marginLeft: 'auto'
    }
};
export const PaginationDots = ({ dots, activeStep, handleActiveStep }) => {
    const DotsToDisplay = [];
    for (let i = 0; i < dots; i += 1) {
        DotsToDisplay.push(<Dot key={i} index={i} active={activeStep} handleClick={handleActiveStep} />);
    }

    return (
        <Box display="flex" justifyContent="center">
            <div style={styles.root}>{DotsToDisplay}</div>
        </Box>
    );
};
